import { Inject, Injectable } from '@angular/core';

import { LOCAL_STORAGE } from '@app/modules/core/tokens/app.tokens';
import { LocalStorage } from '@app/modules/core/interfaces/local-storage';
import { DEVICE_ID } from '@app/modules/core/constants/auth.constants';
import { isNullOrUndefined } from '@app/util/util';
import { newGuid } from '@app/pipes/mappers/generate-guid';

@Injectable({
  providedIn: 'root'
})
export class DeviceIdService {

  constructor(
    @Inject(LOCAL_STORAGE) private localStorage: LocalStorage
  ) { }

  public setDeviceId(): void {
    const deviceId = this.getDeviceIdStorage();
    if (isNullOrUndefined(deviceId)) {
      this.setStorageDeviceId(newGuid());
    }
  }

  public getDeviceId(): string {
    return this.localStorage.getItem(DEVICE_ID);
  }

  private getDeviceIdStorage(): string {
    return this.localStorage.getItem(DEVICE_ID);
  }

  private setStorageDeviceId(deviceId: string): void {
    this.localStorage.setItem(DEVICE_ID, deviceId);
  }

}
